import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_plugin_56947c9c from 'nuxt_plugin_plugin_56947c9c' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_1884c114 from 'nuxt_plugin_sentryserver_1884c114' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_e3f7a424 from 'nuxt_plugin_sentryclient_e3f7a424' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_2a4d265c from 'nuxt_plugin_plugin_2a4d265c' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_appplugin_59c588c0 from 'nuxt_plugin_appplugin_59c588c0' // Source: ../../../../../node_modules/@nuxt/bridge/dist/runtime/app.plugin.mjs (mode: 'all')
import nuxt_plugin_configplugin_01f28022 from 'nuxt_plugin_configplugin_01f28022' // Source: ../../../../../node_modules/@nuxt/bridge/dist/runtime/config.plugin.mjs (mode: 'all')
import nuxt_plugin_distplugin65b9de88_6ce34fe3 from 'nuxt_plugin_distplugin65b9de88_6ce34fe3' // Source: ./dist.plugin.65b9de88.mjs (mode: 'all')
import nuxt_plugin_pluginutils_4b7616c9 from 'nuxt_plugin_pluginutils_4b7616c9' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_0767d458 from 'nuxt_plugin_pluginrouting_0767d458' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_0944c61b from 'nuxt_plugin_pluginmain_0944c61b' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_axios_7ff7b1b2 from 'nuxt_plugin_axios_7ff7b1b2' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_unhead_f0683042 from 'nuxt_plugin_unhead_f0683042' // Source: ../../../../../node_modules/@nuxt/bridge/dist/runtime/head/plugins/unhead (mode: 'all')
import nuxt_plugin_capiplugin_6a7ef3a1 from 'nuxt_plugin_capiplugin_6a7ef3a1' // Source: ./capi.plugin.mjs (mode: 'all')
import nuxt_plugin_errorpluginserver_348551f0 from 'nuxt_plugin_errorpluginserver_348551f0' // Source: ../../../../../node_modules/@nuxt/bridge/dist/runtime/error.plugin.server.mjs (mode: 'server')
import nuxt_plugin_gtm_793d3d08 from 'nuxt_plugin_gtm_793d3d08' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_vuelidate_4345260a from 'nuxt_plugin_vuelidate_4345260a' // Source: ../../../plugins/vuelidate (mode: 'all')
import nuxt_plugin_chart_48b5b2cf from 'nuxt_plugin_chart_48b5b2cf' // Source: ../../../plugins/chart.js (mode: 'client')
import nuxt_plugin_firebase_34d6f690 from 'nuxt_plugin_firebase_34d6f690' // Source: ../../../plugins/firebase.ts (mode: 'all')
import nuxt_plugin_pageTracking_00283cd1 from 'nuxt_plugin_pageTracking_00283cd1' // Source: ../../../plugins/pageTracking.ts (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const store = null
  const router = await createRouter(ssrContext, config, { store })

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Loadsure Insurance Portal","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""},{"name":"apple-mobile-web-app-title","content":"Loadsure"},{"name":"application-name","content":"Loadsure"},{"name":"msapplication-TileColor","content":"#5a734d"},{"name":"theme-color","content":"#5a734d"},{"name":"robots","content":"noindex, nofollow"}],"link":[{"rel":"dns-prefetch","href":"\u002F\u002Fgoogleusercontent.com"},{"rel":"dns-prefetch","href":"\u002F\u002Fgoogleapis.com"},{"rel":"dns-prefetch","href":"\u002F\u002Fgstatic.com"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.googleapis.com"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com","crossorigin":true},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Ficon?family=Material+Icons"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Ficon?family=Material+Icons+Outlined"},{"rel":"stylesheet","href":"https:\u002F\u002Fuse.fontawesome.com\u002Freleases\u002Fv5.0.13\u002Fcss\u002Fall.css"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Saira+Extra+Condensed:wght@100;200;300;400;500;600;700;800;900&display=swap"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Plus+Jakarta+Sans:wght@100;200;300;400;500;600;700;800;900&display=swap"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Fapple-touch-icon.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicon-16x16.png"},{"rel":"manifest","href":"\u002Fsite.webmanifest"},{"rel":"mask-icon","href":"\u002Fsafari-pinned-tab.svg","color":"#5a734d"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"style":[],"script":[{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-N5289MJV')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-N5289MJV&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_56947c9c === 'function') {
    await nuxt_plugin_plugin_56947c9c(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_1884c114 === 'function') {
    await nuxt_plugin_sentryserver_1884c114(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_e3f7a424 === 'function') {
    await nuxt_plugin_sentryclient_e3f7a424(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_2a4d265c === 'function') {
    await nuxt_plugin_plugin_2a4d265c(app.context, inject)
  }

  if (typeof nuxt_plugin_appplugin_59c588c0 === 'function') {
    await nuxt_plugin_appplugin_59c588c0(app.context, inject)
  }

  if (typeof nuxt_plugin_configplugin_01f28022 === 'function') {
    await nuxt_plugin_configplugin_01f28022(app.context, inject)
  }

  if (typeof nuxt_plugin_distplugin65b9de88_6ce34fe3 === 'function') {
    await nuxt_plugin_distplugin65b9de88_6ce34fe3(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_4b7616c9 === 'function') {
    await nuxt_plugin_pluginutils_4b7616c9(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_0767d458 === 'function') {
    await nuxt_plugin_pluginrouting_0767d458(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_0944c61b === 'function') {
    await nuxt_plugin_pluginmain_0944c61b(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_7ff7b1b2 === 'function') {
    await nuxt_plugin_axios_7ff7b1b2(app.context, inject)
  }

  if (typeof nuxt_plugin_unhead_f0683042 === 'function') {
    await nuxt_plugin_unhead_f0683042(app.context, inject)
  }

  if (typeof nuxt_plugin_capiplugin_6a7ef3a1 === 'function') {
    await nuxt_plugin_capiplugin_6a7ef3a1(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_errorpluginserver_348551f0 === 'function') {
    await nuxt_plugin_errorpluginserver_348551f0(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_793d3d08 === 'function') {
    await nuxt_plugin_gtm_793d3d08(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelidate_4345260a === 'function') {
    await nuxt_plugin_vuelidate_4345260a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_chart_48b5b2cf === 'function') {
    await nuxt_plugin_chart_48b5b2cf(app.context, inject)
  }

  if (typeof nuxt_plugin_firebase_34d6f690 === 'function') {
    await nuxt_plugin_firebase_34d6f690(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pageTracking_00283cd1 === 'function') {
    await nuxt_plugin_pageTracking_00283cd1(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
